var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddMedia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9344 1.05747H7.56649C7.19135 1.05747 6.97067 0.95977 6.69483 0.718391L6.3583 0.425287C5.99419 0.109195 5.70732 0 5.16667 0H3.52265C2.5572 0 2 0.574713 2 1.73563V3.27011H14.6667V2.83333C14.6667 1.64943 14.0874 1.05747 12.9344 1.05747Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.33333C2.65333 5.33333 2.31789 5.38144 2 5.47135V4.05172H14.6667V8.88506C14.6667 10.069 14.0929 10.6667 13.0999 10.6667H6.26686C6.52248 10.1666 6.66667 9.60015 6.66667 9C6.66667 6.97496 5.02504 5.33333 3 5.33333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9C6 10.6417 4.62992 12 3 12C1.35827 12 0 10.6535 0 9C0 7.35827 1.35827 6 3 6C4.64764 6 6 7.35827 6 9ZM2.61614 10.5886C2.61614 10.8071 2.79921 10.9488 3.00591 10.9488C3.20669 10.9488 3.38976 10.8071 3.38976 10.5886V9.36024H4.51772C4.7185 9.36024 4.87795 9.19488 4.87795 9C4.87795 8.80512 4.7185 8.63976 4.51772 8.63976H3.38976V7.41732C3.38976 7.19291 3.20669 7.05118 3.00591 7.05118C2.79921 7.05118 2.61614 7.19291 2.61614 7.41732V8.63976H1.48819C1.2874 8.63976 1.12205 8.80512 1.12205 9C1.12205 9.19488 1.2874 9.36024 1.48819 9.36024H2.61614V10.5886Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddMedia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-media.5fc1f868d8270add69fe3357fc71fde8.svg";